export class EStorage {
  id: number;
  url: string | ArrayBuffer;
}
